import { render, staticRenderFns } from "./CongratulationsContainer.vue?vue&type=template&id=e9cff8bc&scoped=true"
import script from "./CongratulationsContainer.vue?vue&type=script&lang=ts"
export * from "./CongratulationsContainer.vue?vue&type=script&lang=ts"
import style0 from "./CongratulationsContainer.vue?vue&type=style&index=0&id=e9cff8bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cff8bc",
  null
  
)

export default component.exports